import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GroupDto } from '@oracychampions/api-interfaces';
import { GroupsService } from '../../group/groups.service';

export const groupResolver: ResolveFn<GroupDto> = (route, state) => {
  const groupsService = inject(GroupsService);

  const id = route.params['id'];

  return groupsService.getGroup(id);
};
